import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ArrowRight from '../../img/ui/ui-arrow-top-right.svg';
import './style.css';

const CTA_POINTS = ['Design', 'Development', 'SEO', 'Analytics'];

const CtaSection = () => {
  const { t } = useTranslation('home');

  return (
    <section className="cta-section section">
      <div className="container">
        <div className="cta-section__card">
          <div className="cta-section__glow cta-section__glow--one" />
          <div className="cta-section__glow cta-section__glow--two" />

          <div className="cta-section__content">
            <div className="cta-section__subtitle">{t('cta.label')}</div>

            <h2 className="cta-section__title title-2">
              {t('cta.title')} <span>{t('cta.titleAccent')}</span>
            </h2>

            <div className="cta-section__desc">
              <p>{t('cta.desc')}</p>
            </div>

            <div className="cta-section__actions">
              <Link to="/contacts" className="button cta-section__button cta-section__button--primary">
                {t('cta.button')}
                <img src={ArrowRight} alt="" aria-hidden="true" />
              </Link>

              <Link to="/projects" className="cta-section__button cta-section__button--secondary">
                {t('cta.secondaryButton')}
              </Link>
            </div>

            <div className="cta-section__meta">
              {CTA_POINTS.map((item) => (
                <span key={item} className="cta-section__chip">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;